import PropTypes from "prop-types"
import { useRemarkSync } from "react-remark"
import remarkGfm from "remark-gfm"

import { components } from "./paragraph-components"

const ArticleMarkdown = ({ children, elementId }) => {
  const markdownContent = useRemarkSync(children, {
    rehypeReactOptions: { components },
    remarkPlugins: [remarkGfm],
    suppressHydrationWarning: true,
  })

  return (
    <div className="desktop:mb-32 mb-16 last:mb-0" id={elementId}>
      {markdownContent}
    </div>
  )
}

ArticleMarkdown.propTypes = {
  children: PropTypes.string,
  elementId: PropTypes.string,
}

export default ArticleMarkdown
